import { render, staticRenderFns } from "./property-bank.vue?vue&type=template&id=5f03bc64&scoped=true&"
import script from "./property-bank.vue?vue&type=script&lang=js&"
export * from "./property-bank.vue?vue&type=script&lang=js&"
import style0 from "./property-bank.vue?vue&type=style&index=0&id=5f03bc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f03bc64",
  null
  
)

export default component.exports